import { useSelector } from 'react-redux';

const useCurrentUserPermissions: Function = (): string[] => {
  const currentUser: User = useSelector(({ app }: Reducers): User => app.baseData && app.baseData.currentUser);

  return (currentUser && currentUser.permissions) || [];
};

export default useCurrentUserPermissions;
